"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var infinite_scroll_directive_1 = require("./infinite-scroll.directive");
var InfiniteScrollModule = (function () {
    function InfiniteScrollModule() {
    }
    InfiniteScrollModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    declarations: [infinite_scroll_directive_1.InfiniteScrollDirective],
                    exports: [infinite_scroll_directive_1.InfiniteScrollDirective]
                },] },
    ];
    InfiniteScrollModule.ctorParameters = function () { return []; };
    return InfiniteScrollModule;
}());
exports.InfiniteScrollModule = InfiniteScrollModule;
//# sourceMappingURL=infinite-scroll.module.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ng-infinitescroll/dist/infinite-scroll.module.js
// module id = ../../../../ng-infinitescroll/dist/infinite-scroll.module.js
// module chunks = vendor